module.exports = __webpack_public_path__ + "img/villa_carafa.b9f56937.png";